// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: nzwm_0AVBn4
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import TopBar from "../../TopBar"; // plasmic-import: MnkTdPJ0xv/component
import NotPaidStatusCard from "../../NotPaidStatusCard"; // plasmic-import: 2sctKAwH4G/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicPaymentInstance.module.css"; // plasmic-import: nzwm_0AVBn4/css
import Line6Icon from "./icons/PlasmicIcon__Line6"; // plasmic-import: x6cQJ36_PF/icon
import image9JoGvhUlyFdD from "./images/image9.png"; // plasmic-import: joGVHUly-fdD/picture

createPlasmicElementProxy;

export const PlasmicPaymentInstance__VariantProps = new Array();

export const PlasmicPaymentInstance__ArgProps = new Array(
  "paymentType",
  "paymentAmount",
  "createdDate1",
  "createdDate2",
  "paymentSuccessDate",
  "clientCompany",
  "paymentMethod",
  "cancelType2",
  "cancelType3"
);

const $$ = {};

function PlasmicPaymentInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
            />

            <div
              data-plasmic-name={"figmaPaste"}
              data-plasmic-override={overrides.figmaPaste}
              className={classNames(projectcss.all, sty.figmaPaste)}
            >
              <div className={classNames(projectcss.all, sty.freeBox___7FEf3)}>
                {p.renderPlasmicSlot({
                  defaultContents: " ",
                  value: args.paymentAmount,
                  className: classNames(sty.slotTargetPaymentAmount)
                })}
                <div
                  data-plasmic-name={"paymentStatusStack"}
                  data-plasmic-override={overrides.paymentStatusStack}
                  className={classNames(projectcss.all, sty.paymentStatusStack)}
                >
                  <NotPaidStatusCard
                    data-plasmic-name={"notPaidStatusCard"}
                    data-plasmic-override={overrides.notPaidStatusCard}
                    className={classNames(
                      "__wab_instance",
                      sty.notPaidStatusCard
                    )}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___72QXc)}>
                {p.renderPlasmicSlot({
                  defaultContents: " ",
                  value: args.paymentType,
                  className: classNames(sty.slotTargetPaymentType)
                })}
              </div>
              <p.Stack
                as={"div"}
                data-plasmic-name={"optionStack"}
                data-plasmic-override={overrides.optionStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.optionStack)}
              >
                <div
                  data-plasmic-name={"stopAutomation"}
                  data-plasmic-override={overrides.stopAutomation}
                  className={classNames(projectcss.all, sty.stopAutomation)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__u1P7W
                    )}
                  >
                    {"Stop Automation"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"editSubscription"}
                  data-plasmic-override={overrides.editSubscription}
                  className={classNames(projectcss.all, sty.editSubscription)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__egiZs
                    )}
                  >
                    {"Edit Subscription"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"voidPayment"}
                  data-plasmic-override={overrides.voidPayment}
                  className={classNames(projectcss.all, sty.voidPayment)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__bsJwq)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "Void Payment",
                      value: args.cancelType2,
                      className: classNames(sty.slotTargetCancelType2)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"markAsPaid"}
                  data-plasmic-override={overrides.markAsPaid}
                  className={classNames(projectcss.all, sty.markAsPaid)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__k2Z3P)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "Mark As Paid",
                      value: args.cancelType3,
                      className: classNames(sty.slotTargetCancelType3)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"refundButton"}
                  data-plasmic-override={overrides.refundButton}
                  className={classNames(projectcss.all, sty.refundButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__sYkuj
                    )}
                  >
                    {"Refund"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"receiptButton"}
                  data-plasmic-override={overrides.receiptButton}
                  className={classNames(projectcss.all, sty.receiptButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__mcoBs
                    )}
                  >
                    {"View Receipt"}
                  </div>
                </div>
              </p.Stack>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__rWLfB)}>
              <div className={classNames(projectcss.all, sty.freeBox__u4Yoh)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nIm3Y
                  )}
                >
                  {"Date"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__zjqmz)}>
                  {p.renderPlasmicSlot({
                    defaultContents: " ",
                    value: args.createdDate1,
                    className: classNames(sty.slotTargetCreatedDate1)
                  })}
                </div>
              </div>
              <div
                className={classNames(projectcss.all, sty.freeBox___1ZApo)}
              />

              <div className={classNames(projectcss.all, sty.freeBox___5AoZq)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__eSvgV
                  )}
                >
                  {"Customer"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__nRlGb)}>
                  {p.renderPlasmicSlot({
                    defaultContents: " ",
                    value: args.clientCompany,
                    className: classNames(sty.slotTargetClientCompany)
                  })}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__gIc5I)} />
              <div className={classNames(projectcss.all, sty.freeBox__bd9HL)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0HPdn
                  )}
                >
                  {"Payment Method"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__yLnEq)}>
                  {p.renderPlasmicSlot({
                    defaultContents: " ",
                    value: args.paymentMethod,
                    className: classNames(sty.slotTargetPaymentMethod)
                  })}
                </div>
              </div>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__inOVa
              )}
            >
              {"Payment History"}
            </div>
            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Notes"}
            </div>
            <Line6Icon
              data-plasmic-name={"svg"}
              data-plasmic-override={overrides.svg}
              className={classNames(projectcss.all, sty.svg)}
              role={"img"}
            />

            <div className={classNames(projectcss.all, sty.freeBox__sOvOg)}>
              {p.renderPlasmicSlot({
                defaultContents: " ",
                value: args.paymentSuccessDate,
                className: classNames(sty.slotTargetPaymentSuccessDate)
              })}
            </div>
            <div
              data-plasmic-name={"paymentLinkStack"}
              data-plasmic-override={overrides.paymentLinkStack}
              className={classNames(projectcss.all, sty.paymentLinkStack)}
            >
              <div
                data-plasmic-name={"paymentLink"}
                data-plasmic-override={overrides.paymentLink}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.paymentLink
                )}
              >
                {"Payment Link Created"}
              </div>
              <p.PlasmicImg
                data-plasmic-name={"paymentLinkImage"}
                data-plasmic-override={overrides.paymentLinkImage}
                alt={""}
                className={classNames(sty.paymentLinkImage)}
                displayHeight={"4%"}
                displayMaxHeight={"none"}
                displayMaxWidth={"4%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loading={"lazy"}
                src={{
                  src: image9JoGvhUlyFdD,
                  fullWidth: 256,
                  fullHeight: 256,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__lTqE)}>
              {p.renderPlasmicSlot({
                defaultContents: " ",
                value: args.createdDate2,
                className: classNames(sty.slotTargetCreatedDate2)
              })}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___8FiFu
              )}
            >
              {"Payment Succeeded"}
            </div>
            <div
              data-plasmic-name={"rectangle50"}
              data-plasmic-override={overrides.rectangle50}
              className={classNames(projectcss.all, sty.rectangle50)}
            >
              <textarea
                data-plasmic-name={"paymentNotes"}
                data-plasmic-override={overrides.paymentNotes}
                className={classNames(
                  projectcss.all,
                  projectcss.textarea,
                  sty.paymentNotes
                )}
                ref={ref => {
                  $refs["paymentNotes"] = ref;
                }}
                value={"This is a text area."}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "topBar",
    "figmaPaste",
    "paymentStatusStack",
    "notPaidStatusCard",
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton",
    "title",
    "svg",
    "paymentLinkStack",
    "paymentLink",
    "paymentLinkImage",
    "rectangle50",
    "paymentNotes"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "topBar",
    "figmaPaste",
    "paymentStatusStack",
    "notPaidStatusCard",
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton",
    "title",
    "svg",
    "paymentLinkStack",
    "paymentLink",
    "paymentLinkImage",
    "rectangle50",
    "paymentNotes"
  ],

  topBar: ["topBar"],
  figmaPaste: [
    "figmaPaste",
    "paymentStatusStack",
    "notPaidStatusCard",
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton"
  ],

  paymentStatusStack: ["paymentStatusStack", "notPaidStatusCard"],
  notPaidStatusCard: ["notPaidStatusCard"],
  optionStack: [
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton"
  ],

  stopAutomation: ["stopAutomation"],
  editSubscription: ["editSubscription"],
  voidPayment: ["voidPayment"],
  markAsPaid: ["markAsPaid"],
  refundButton: ["refundButton"],
  receiptButton: ["receiptButton"],
  title: ["title"],
  svg: ["svg"],
  paymentLinkStack: ["paymentLinkStack", "paymentLink", "paymentLinkImage"],
  paymentLink: ["paymentLink"],
  paymentLinkImage: ["paymentLinkImage"],
  rectangle50: ["rectangle50", "paymentNotes"],
  paymentNotes: ["paymentNotes"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentInstance__ArgProps,
          internalVariantPropNames: PlasmicPaymentInstance__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentInstance";
  } else {
    func.displayName = `PlasmicPaymentInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentInstance = Object.assign(
  // Top-level PlasmicPaymentInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    topBar: makeNodeComponent("topBar"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    paymentStatusStack: makeNodeComponent("paymentStatusStack"),
    notPaidStatusCard: makeNodeComponent("notPaidStatusCard"),
    optionStack: makeNodeComponent("optionStack"),
    stopAutomation: makeNodeComponent("stopAutomation"),
    editSubscription: makeNodeComponent("editSubscription"),
    voidPayment: makeNodeComponent("voidPayment"),
    markAsPaid: makeNodeComponent("markAsPaid"),
    refundButton: makeNodeComponent("refundButton"),
    receiptButton: makeNodeComponent("receiptButton"),
    title: makeNodeComponent("title"),
    svg: makeNodeComponent("svg"),
    paymentLinkStack: makeNodeComponent("paymentLinkStack"),
    paymentLink: makeNodeComponent("paymentLink"),
    paymentLinkImage: makeNodeComponent("paymentLinkImage"),
    rectangle50: makeNodeComponent("rectangle50"),
    paymentNotes: makeNodeComponent("paymentNotes"),
    // Metadata about props expected for PlasmicPaymentInstance
    internalVariantProps: PlasmicPaymentInstance__VariantProps,
    internalArgProps: PlasmicPaymentInstance__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPaymentInstance;
/* prettier-ignore-end */
